export enum AuctionState {
  Closed = 'closed',
  Deleted = 'deleted',
  Open = 'open',
  Paused = 'paused',
  Pending = 'pending',
}
